import { useSyncExternalStore } from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { RequireAuth } from "@/app/auth/guards"
import { useNbrAuth } from "@/app/auth/useNbrAuth"
import { getAccessToken, subscribeToTokens } from "@/shared/auth/tokenStore"
import CabinetLayout from "@/widgets/cabinet/CabinetLayout"
import { isCabinetPath, isSectionPath } from "@/widgets/cabinet/cabinetNav"
import MainLayout from "@/widgets/layout/MainLayout"
import { LoadingBlock } from "@/widgets/LoadingBlock"

/**
 * Вошедший смотрит разделы сайта в оболочке кабинета.
 * Пока сессия восстанавливается, наличие access token решает, не показывать ли публичную шапку.
 * Без токена — тихая загрузка: публичный сайт появится только когда сессии точно нет.
 */
export default function AppShell() {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const auth = useNbrAuth()
  const token = useSyncExternalStore(subscribeToTokens, getAccessToken, () => null)
  const session = auth.isLoading ? Boolean(token) : auth.isAuthenticated

  if (isCabinetPath(pathname)) {
    return (
      <RequireAuth>
        <CabinetLayout />
      </RequireAuth>
    )
  }

  if (isSectionPath(pathname) && auth.isLoading && !session) {
    return (
      <div className="min-h-screen bg-lib-bg">
        <LoadingBlock variant="page" message={t("common.loading")} />
      </div>
    )
  }

  if (isSectionPath(pathname) && session) return <CabinetLayout />
  return <MainLayout />
}
